import { fetcherAndLog } from '@utils/fetcher';
import { User } from 'next-firebase-auth';
import { getBaseUrl } from '@utils/general-utils';
import { userToken } from '@utils/firebase/initAuth';

export interface InstanceMachine {
  type: 'instance';
  id: string;
  slug: string;
  previewUrl: string;
  publicUrl: string;
  createdAt: string;
  lastAccessedAt: string;
  displayName: string;
  isPinned: boolean;
  isDeploymentEnabled: boolean;
}

export async function fetchInstanceMachines(
  user: User,
): Promise<InstanceMachine[]> {
  const token = await userToken(user);
  const result = await fetcherAndLog(`${getBaseUrl(false)}/instances`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!result.ok) {
    const { message } = await result.json();
    throw new Error(
      `Could not fetch machines - ${result.statusText} (${result.status})${
        message ? `: ${message}` : ''
      }`,
    );
  }
  return (await result.json()).machines.map((machine: InstanceMachine) => ({
    ...machine,
    type: 'instance',
  }));
}

export async function getLoginToken(user: User) {
  const token = await userToken(user);
  const result = await fetcherAndLog(
    `${getBaseUrl(false)}/instance/login-token`,
    {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return (await result.json()).token;
}
